/* eslint-disable */
import React, { useState } from "react";
import Body from "./Body";
const Structure = () => {
  const [representColors, setRepresentColors] = useState([
    { role: "President", color: "#f8a2c6" }, // Pink
    { role: "General Secretary", color: "#a2a2f8" }, // Light Blue
    { role: "Asst. Secretary", color: "#f8c976" }, // Yellow
    { role: "Financial officer", color: "#7fd9d9" }, // Cyan
    { role: "Members", color: "#f26b6b" }, // Red
    { role: "Head master", color: "#6b6b6b" }, // Grey
    { role: "Teacher In charge", color: "#99a86c" }, // Olive Green
    { role: "Class Teachers", color: "#5978d9" }, // Blue
    { role: "Teachers", color: "#f89a5c" }, // Orange
    { role: "Students", color: "#a0a0a0" }, // Light Grey
  ]);

  const [boardStructure, setBoardStructure] = useState({
    name: "CEO",
    nodeColor: "#f498c6",
    children: [
      {
        name: "Manager",
        nodeColor: "#a7a9f7",
        attributes: {
          department: "Production",
        },
        children: [
          {
            name: "Foreman",
            nodeColor: "#f9c876",
            attributes: {
              department: "Fabrication",
            },
          },
          {
            name: "Foreman",
            nodeColor: "#f97678",
            attributes: {
              department: "Assembly",
            },
          },
          {
            name: "Foreman",
            nodeColor: "#7bd7cd",
            attributes: {
              department: "Assembly",
            },
          },
        ],
      },
    ],
  });
  const _this = { boardStructure, representColors };
  return <Body {..._this} />;
};

export default Structure;
